@if (screenLayoutService.desktopAny$ | async) {
  <sh-access-bar
    #accessbar
    slot="access"
    label="{{ 'app.title' | translate }}"
    (logo-clicked)="goHome()"
    cursor-change
  >
    <div slot="tabs" class="desktop-search">
      <ng-container *ngTemplateOutlet="search"></ng-container>
    </div>
    <app-user-documentation slot="functions"></app-user-documentation>
    <app-component-settings
      slot="functions"
      [menuMode]="true"
    ></app-component-settings>
    <app-useful-applications
      slot="functions"
      [menuMode]="true"
      [allowSystemContext]="isLandingPage() ? false : true"
    ></app-useful-applications>
    <app-authorized slot="user" [menuMode]="true"></app-authorized>
  </sh-access-bar>
}

@if ((screenLayoutService.desktopAny$ | async) === false) {
  <div
    slot="access"
    (logo-clicked)="goHome()"
    [ngClass]="{
      accessBar: true,
      hide: (routeService.searchPageOpen$ | async) === true,
    }"
  >
    <!-- menu icon -->
    @if ((routeService.backButtonVisible$ | async) === false) {
      <sh-icon
        button
        icon="menu"
        aria-label="Open Menu"
        (click)="openMenu()"
      ></sh-icon>
    }
    <!-- back button (controlled by RouteService) -->
    @if (routeService.backButtonVisible$ | async) {
      <sh-icon
        mobile
        button
        aria-label="Go back"
        [icon]="routeService.backButtonIcon$ | async"
        (click)="routeService.pressBackButton()"
      ></sh-icon>
    }
    <!-- app-authorized></app-authorized -->
    <ng-container *ngTemplateOutlet="search"></ng-container>
    <sh-icon
      slot="right"
      button
      icon="apps"
      aria-label="Apps"
      (click)="openApps()"
    ></sh-icon>
  </div>
}

<div class="content">
  <router-outlet></router-outlet>
</div>

<ng-template #search>
  <div
    class="advanced-search-btn"
    *ngIf="isAuthorized$ | async"
    [ngClass]="{ 'active-underline': router.url === '/advancedSearch' }"
  >
    <sh-icon
      icon="filter-search"
      button
      [attr.aria-label]="'label.advancedSearch' | translate"
      (click)="routeToAdvancedSearch()"
    ></sh-icon>
    <sh-text
      class="search-text"
      size="body-2"
      (click)="routeToAdvancedSearch()"
      >{{ 'label.advancedSearch' | translate }}</sh-text
    >
  </div>
  <app-search-pane *ngIf="isAuthorized$ | async"></app-search-pane>
</ng-template>

<!-- main menu drawer -->
<sh-drawer #drawerMenu position="left">
  <sh-icon
    button
    icon="cancel"
    size="s"
    color="secondary"
    (click)="closeMenu()"
  ></sh-icon>
  @if (userService.userData$ | async; as userData) {
    <sh-user-identifier
      [name]="userData.displayName"
      [initials]="userService.userInitials$ | async"
      [image]="(userService.userProfilePicture$ | async) || null"
    >
    </sh-user-identifier>
    <sh-text email>{{ userData.mail }}</sh-text>
    <sh-button
      logout
      label="Logout"
      color="secondary"
      (click)="userService.logout()"
    ></sh-button>
  }
  <sh-divider></sh-divider>
  <sh-menu-item
    [toggle]="false"
    icon-size="s"
    icon="home"
    label="SeSO Start Page"
    (click)="goHome()"
  ></sh-menu-item>
  <sh-menu-item
    [toggle]="false"
    icon-size="s"
    icon="filter-search"
    label="Advanced Search"
    (click)="routeToAdvancedSearch()"
  ></sh-menu-item>
  <sh-menu-item
    [toggle]="false"
    icon-size="s"
    icon="settings"
    aria-label="Settings"
    label="Settings"
    (click)="goToSettings()"
  ></sh-menu-item>
  <sh-menu-item
    [toggle]="false"
    icon-size="s"
    icon="help"
    aria-label="Help"
    label="Help"
    (click)="handleEventClick($event)"
  >
    @if (isWhatsNewEnabled) {
      <sh-menu-item
        [label]="'label.whatsNew' | translate"
        [toggle]="false"
        (click)="showWhatsNewModal()"
      ></sh-menu-item>
    }
    <sh-menu-item
      [label]="'label.releaseNotes' | translate"
      (click)="routeToReleaseNotes()"
      [toggle]="false"
    ></sh-menu-item>
    <sh-menu-item
      [label]="'label.getHelpLink' | translate"
      (click)="getHelp()"
      [toggle]="false"
    ></sh-menu-item>
    @if (announcementService.hiddenAnnouncement$ | async; as announcement) {
      <sh-menu-item
        label="{{ 'label.latestAnnouncement' | translate }} ({{
          announcement.creationTimeOrLabel
            | localizedDate: 'longFormat' : announcement.creationTimeOrLabel
        }})"
        [toggle]="false"
        (click)="announcementService.closeAnnouncement(); closeMenu()"
      >
      </sh-menu-item>
    }
  </sh-menu-item>
</sh-drawer>

<!-- apps drawer -->
<sh-drawer #drawerApps position="right"
  ><sh-icon
    button
    icon="cancel"
    aria-label="Cancel"
    size="s"
    color="secondary"
    (click)="closeApps()"
  ></sh-icon>
  <app-useful-applications
    [menuMode]="false"
    [allowSystemContext]="isLandingPage() ? false : true"
  ></app-useful-applications>
</sh-drawer>
@if (isWhatsNewEnabled) {
  <app-feature-details></app-feature-details>
}
@if ((routeService.hideAppFooter$ | async) !== true) {
  <app-footer></app-footer>
}
